import { render } from "./IconColors.vue?vue&type=template&id=2f9c3186"
import script from "./IconColors.vue?vue&type=script&lang=ts"
export * from "./IconColors.vue?vue&type=script&lang=ts"
script.render = render

export default script